<template>
<div class="personalAuth">
    <div class="personalTitleAuthBox">
        <span>|</span>个人认证
    </div>
    <div class="form page-form">
        <el-form :model="personalAuthForm" :rules="rules" ref="personalAuthForm" label-width="150px" class="demo-ruleForm" label-position="left" size="mini">
            <el-form-item label="姓名" prop="personname">
                <el-input v-model="personalAuthForm.personname" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" prop="personidno">
                <el-input v-model="personalAuthForm.personidno" placeholder="请输入身份证号码"></el-input>
            </el-form-item>
            <el-form-item label="证件照片" prop="headImage" class="headImage">
                <div class="idCardBox">
                    <upload class="frontIdcardImage" :imgRule="frontIdCardImage" tips="上传手持身份证正面" @setImage="setFrontImgUrl" :uploadType="uploadType"></upload>
                </div>
            </el-form-item>
            <div class="imgTips">
                <div class="success title">照片样式</div>
                <div class="handheld-idcard-cls">
                    <img :src="handheldIdcardUrl" alt="">
                </div>
                <div class="el-upload__tip">支持JPG／JPEG／PNG格式，大小不超过2M。</div>
            </div>
            <el-form-item>
                <el-button type="primary" @click="submitForm('personalAuthForm')">提交</el-button>
                <el-button @click="cancel">返回</el-button>
            </el-form-item>
        </el-form>
    </div>
</div>
</template>

<script>
import Upload from 'base/upload/upload'
import {formatFileInfo} from '@/common/js/tools'
import {personalAuthMsg} from '@/api/accountApi'
export default {
    name: 'personalAuth',
    data() {
        let checkName = (rule, value, callback) => {
            let nameRegular = /[a-zA-Z\u4E00-\u9FA5]+$/
            if (!nameRegular.test(value)) {
                callback(new Error('请输入正确的名字'))
            } else {
                callback()
            }
        }
        let checkIdCard = (rule, value, callback) => {
            let idCardRegular = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
            if (!idCardRegular.test(value)) {
                callback(new Error('请输入正确的身份证号码'))
            } else {
                callback()
            }
        }
        let checkLogoUrl = (rule, value, callback) => {
            if (!this.personalAuthForm.imageinfo.furl) {
                callback(new Error('请选择身份证图片'))
            } else {
                callback()
            }
        }
        return {
            handheldIdcardUrl: require('@/common/images/other/handheld_idcard.png'),
            realName: false,
            personalAuthForm: {
                personname: '',
                personidno: '',
                imageinfo: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                } // 个人身份证图片
            },
            // 上传七牛配置参数
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            frontIdCardImage: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg,image/gif',
                size: 2,
                width: 0,
                height: 0
            },
            backIdcardImage: {
                cls: 'icon_upload',
                accept: 'image/png,image/jpeg,image/gif',
                size: 2,
                width: 0,
                height: 0
            },
            rules: {
                personname: [
                    {required: true, message: '请输入名称', trigger: 'blur'},
                    {min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur'},
                    {validator: checkName, trigger: 'blur'}
                ],
                personidno: [
                    {required: true, message: '请输入身份证号码', trigger: 'blur'},
                    {validator: checkIdCard, trigger: 'blur'}
                ],
                headImage: [
                    {validator: checkLogoUrl, trigger: 'blur'}
                ]
            }
        }
    },
    props: [
        'authMsg'
    ],
    mounted() {
    },
    methods: {
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$confirm('确定要提交账户资料吗？提交后我们需要1～3个工作日进行审核！亲耐心等待。', '提交资料', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this.personalAuthForm.imageinfo = formatFileInfo(this.personalAuthForm.imageinfo)
                        personalAuthMsg({
                            data: Object.assign({}, this.personalAuthForm),
                            success: data => {
                                if (data.code === '000') {
                                    this.$message({
                                        type: 'success',
                                        message: '提交成功'
                                    })
                                    this.$router.push('/accountMgt/accountAuth/accountAuthView')
                                } else {
                                    this.$message.error(data.msg)
                                }
                            },
                            error: data => {
                                this.$message.error(data.msg)
                            }
                        })
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
                } else {
                    this.$message.error('请填写完整的资料')
                    return false
                }
            })
        },
        // 身份证正面图片
        setFrontImgUrl(url, id) {
            this.personalAuthForm.imageinfo = url
        },
        cancel() {
            this.$router.push('/accountMgt/accountAuth/accountAuthView')
        }
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
        Upload
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/variable";
.personalAuth {
    .idcardImage .avatar-uploader{
        box-sizing: border-box;
        width: 320px;
        height: 180px;
    }
    .title{
        font-size: $font-16;
        padding: 15px 0;
    }
    .handheld-idcard-cls{
        width: 186px;
        height: 186px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .el-upload__tip {
        color: $tcolor-grey;
    }
    .el-input{
        width: 400px;
    }
    .el-upload__text{
        color: #909399;
    }
    .personalTitleAuthBox{
        font-weight: 500;
        font-size: 16px;
        span{
            margin-right: 5px;
            color: #409EFF;
        }
    }
    .imgTips{
        margin-left: 150px;
        margin-bottom: 40px;
    }
    .headImage{
        .el-form-item__error{
            padding-top: 4px;
        }
    }
    .idCardBox{
        display: flex;
        .backIdcardImage{
            margin-left: 30px;
        }
        .upload{
            .avatar-uploader{
                width: 320px;
                height: 180px;
            }
        }
    }
}
</style>
